import { translateFun } from "../Translation";
import React, { useEffect } from "react";

export default function ListAccordianASCO(props) {
    const {
      Title,
      ListData,
      Count,
      IsAddAction = false,
      AccQtyDecrClick,
      AccAddBtnClick,
      intialPartsarray,
      AccordionKey,
      IsDeleteItemAction = false,
      ItemDeleteClick,
      IsExpanded,
      setExpanded,
      productForImageModal,
      setProductForImageModal,
      DisplayResultCount,
      setImageModalLoader,
      param,
      handleOpen,
      Accordion,
      AccordionSummary,
      Typography,
      List,
      ListItem,
      ListItemAvatar,
      Avatar,
      ListItemText,
      Button,
      Tooltip,
      ExpandMoreIcon,
      AddIcon,
      CancelIcon,
      RemoveCircleIcon,
      InfoRoundedIcon,
      disbAccArr,
      AccAddMandatory,
      mandSelAccArr
    } = props;

    const MiAStyle = {
      position: 'absolute',
      zIndex: 2,
      top: 0,
      left: 13,
      height: 'auto'
    };

    const disbAccClkStyle = {
        pointerEvents: 'none',
        cursor: 'default',
        opacity: 0.3,
      };

    useEffect(() => {
      if(param == 'qacomponent')
      {
        const mandAccListArr      = [];
        const mandAccListIndexArr = [];
        ListData.forEach((eachAccList, mandAccKey) => {
          let chkMandAcc  = eachAccList?.isMandatory === 'Y' ? 1 : 0;
          if(chkMandAcc == 1)
          {
            mandAccListArr[mandAccKey]  = eachAccList;
            mandAccListIndexArr.push(mandAccKey);
          }
        });
        if(mandAccListArr.length > 0)
          AccAddMandatory(mandAccListArr, mandAccListIndexArr);
      }
    }, [ListData]);  
  
    return (
      <Accordion expanded={IsExpanded} key={AccordionKey}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="accordion-summary"
          onClick={() => setExpanded(!IsExpanded)}
        >
          <Typography className="accordion-header-title">
            {Title}
            <span className="badge">{Count}</span>
            {DisplayResultCount ? (
              <span className="result">{`(${ListData.length}) ${translateFun("Results")}`}</span>
            ) : null}
          </Typography>
        </AccordionSummary>
  
        {ListData.map((data, aIndex) => (
          <List
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper",
              cursor: "pointer",
            }}
            key={aIndex}
            style={(Object.values(disbAccArr).some(daccArr => daccArr.includes(data["Catalog"]))) ? disbAccClkStyle : { cursor: "unset" }}
            className="part_acs_ul"
          >
            <ListItem key={"ListItem" + aIndex}>
              <ListItemAvatar
                className={
                  data?.Catalog === productForImageModal?.Catalog
                    ? "catalog-code_active Avatar_image "
                    : "Avatar_image"
                }
              >
                {(data?.Description?.includes("TAA") || data?.Description?.includes("BAA") || data?.Description?.includes("BABA")) 
                && (
                        <img
                        src={process.env.PUBLIC_URL + "/asset/images/MiA_Logo.png"}
                        alt="MiA" height="40%" width="6%" title="MiA" 
                        style={MiAStyle}
                    />
                )}
                <Avatar
                  variant="square"
                  alt="Remy Sharp"
                  src={
                    data?.Image_Url
                      ? data?.Image_Url
                      : process.env.PUBLIC_URL + "/asset/images/no Image_av.png"
                  }
                />
                <div className={"catalog_div"}>
                  <div className="code-info">
                    <div className="description_div">
                      <ListItemText
                        className={"detailsButton catelog-code"}
                        primary={data["Catalog"]}
                        // onClick={() => {
  
                        // }}
                        onClick={() => {
                          if (setProductForImageModal) {
                            setProductForImageModal({});
                            setImageModalLoader(true);
                            // setproductNo(data);
                            setProductForImageModal(data);
                            if (param == "qacomponent") {
                              handleOpen();
                            } else {
                              // setImageUrl("");
                            }
                            if (data.Thumbnail_Image_Url) {
                              // setImageUrl(
                              //   data?.Thumbnail_Image_Url?.split("File_Ext")[0] +
                              //   "File_Ext=.JPG"
                              // );
                            }
                          }
                        }}
                      ></ListItemText>
                      {!data?.localStockCode?.startsWith("Stock") && (
                        <Tooltip title="May not be in stock, please check">
                          <InfoRoundedIcon />
                        </Tooltip>
                      )}
  
                      {AccordionKey === "PartsSection" ? (
                        <label className="qut-info">{`x${data.partsQuantity}`}</label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
  
                  <Tooltip id="catelog-detail-tooltip">
                    <ListItemText
                      className="catelog-detail"
                      primary={data.Description}
                    />
                  </Tooltip>
                </div>
              </ListItemAvatar>
              <div className="content-info">
                {IsAddAction == true ? (
                  <div className="add-btn" key={aIndex}>
                    {!intialPartsarray[aIndex] ? (
                      <Button
                        variant="contained"
                        onClick={() => AccAddBtnClick({ aIndex, data })}
                      >
                        <AddIcon /> {translateFun("Add")}
                      </Button>
                    ) : (
                      <span className="quatity-btns">
                        {(data?.isMandatory === 'Y' || (Object.values(mandSelAccArr).some(msaccArr => msaccArr.includes(data["Catalog"])))) && intialPartsarray[aIndex]?.quantity === 1 ? 
                          ("") :
                          ( 
                          <Button
                          variant='contained'
                          onClick={() => AccQtyDecrClick({ aIndex, data })}
                          disabled={
                            data?.isMandatory === 'Y' &&
                              intialPartsarray[aIndex]?.quantity === 1
                              ? true
                              : false
                          }
                          /*
                          { ...(data?.isMandatory === 'Y' &&
                          intialPartsarray[aIndex]?.quantity === 1
                            ? { style: { color: "lightgray", height: "23px", width: "62px" } }
                          : {}) }
                          */
                          >
                            <RemoveCircleIcon />
                          </Button>
                          )
                        }
                        <h4>{intialPartsarray[aIndex]?.quantity}</h4>
                      </span>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </ListItem>
            {IsDeleteItemAction == true ? (
              <div className="delete-cart-item-btn">
                <Button
                  variant="contained"
                  onClick={() => {
                    ItemDeleteClick(aIndex);
                  }}
                >
                  <Tooltip title={translateFun("RemovedItems")}>
                    <CancelIcon />
                  </Tooltip>
                </Button>
              </div>
            ) : (
              ""
            )}
          </List>
        ))}
      </Accordion>
    );
  };